(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    document.querySelectorAll('[data-am-mobile-video]').forEach(video => {
      if (video.dataset.amReady) return;
      video.dataset.amReady = 'true';
      video.loop = true;
      video.muted = true;
      function update() {
        if (!mobile.matches || reduced.matches || document.hidden) {
          video.pause();
          return;
        }
        if (!video.getAttribute('src')) {
          video.src = video.dataset.amSrc;
          video.load();
        }
        video.play().catch(() => {});
      }
      video.addEventListener('error', () => { video.style.display = 'none'; });
      mobile.addEventListener('change', update);
      reduced.addEventListener('change', update);
      document.addEventListener('visibilitychange', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();